import React from 'react';
import { css, StyleSheet } from 'aphrodite';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { UiHelper } from '../../common/helpers/UiHelper';
import { AppUiHelper } from '../../helpers/AppUiHelper';
import { AppStyles } from '../../styles/AppTheme';
import { Tooltip } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { AppHelper } from '../../helpers/AppHelper';

export class CustomFields extends BaseEntityPage {

  constructor(props, options) {
    super(props, options)
    this.pageKey = 'CustomFields'
    this.pageTitle = Helper.getString('customField')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.uploadLocation = this.orgId
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: this.pageTitle },
    ]
    this.toFetch = [
      { method: 'GET', paths: ['devicecfs'], queryParams: { groupId: this.orgId, pb: 'fieldDefCfSuggestions' } },
    ]
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Info: (current) => current.title,
      Suggestions: (current) => {
        return (
          Helper.getString('suggestions') + ': ' + Object.keys(current.suggestions).length || 0
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
      groupId: this.orgId
    }
    this.addNewLabel = 'Add Field'
    this.noTableHead = true
    this.allowAccessToRoles = ['VENUES']
    if(!UiHelper.isUserHasRoles(this.allowAccessToRoles)) this.noAdd = true
  }

  onFetchSuccess(results) {
    for (const f of results[0].fieldDefCfSuggestions.steps[0].fields) {
      if(f.key === 'title') {
        f.label = Helper.getString('customFieldLabel')
      }
    }
    this.formDefinition = this.fieldDef = results[0].fieldDefCfSuggestions
    this.setState({
      items: results[0].items
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.setState({
      apiMethod: 'POST',
      apiData: { orgId: this.orgId },
      apiEndPoint: ApiHelper.makeUrlPath(['devicecfs']),
    });
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiData: { orgId: this.orgId },
      apiEndPoint: ApiHelper.makeUrlPath(['devicecfs', current.id]),
    });
  }


  onActions(current) {
    const actions = []
    UiHelper.addActionButtonByRole(actions, UiHelper.buttonEdit(this, current), this.allowAccessToRoles)
    UiHelper.addActionButtonByRole(actions, this.fieldOptionsButton(current))
    return actions
  }

  fieldOptionsButton(current) {
    return (
      <Tooltip title={Helper.getString('fieldOptions')} placement='top-start' key={'infoBtn'}>
        <Link to={`/admin/partners/${this.orgId}/custom-fields/${current.id}/suggestions`} className={css(AppStyles.entityTableLinkIcon)}>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined'>text_fields</i>
          </span>
        </Link>
      </Tooltip>
    )
  }
}

const Styles = StyleSheet.create({
  actionIconImage:{
    width: 20,
    height: 20
  },
  spanValue: {
    fontSize: 12
  },
  img: {
    height: 30
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/CustomFields.js